/**
 *
 * ImportGpx
 *
 */

import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { FormattedMessage } from 'react-intl';
import messages from './messages';
import useGpxUpload from './useGpxUpload';

const Wrapper = styled.div`
  [type='file'] {
    border: 0;
    clip: rect(0, 0, 0, 0);
    height: 1px;
    overflow: hidden;
    padding: 0;
    position: absolute !important;
    white-space: nowrap;
    width: 1px;
  }

  [type='file']:focus + label {
    outline: 1px dotted #000;
    outline: -webkit-focus-ring-color auto 5px;
    background-color: #3071a9;
    border-color: #285e8e;
  }
`;

function ImportGpx(props) {
  const { className, disabled, title, onChange } = props;
  const gpxUpload = useGpxUpload();
  function uploadFile(ev) {
    if (onChange) {
      onChange();
    }
    gpxUpload(ev.target.files[0]);
    ev.target.value = ''; // eslint-disable-line no-param-reassign
  }

  return (
    <Wrapper title={title}>
      <input
        type="file"
        name="file-input"
        id="file-input"
        accept=".gpx"
        disabled={disabled}
        onChange={uploadFile}
      />
      <p>
        <label htmlFor="file-input" disabled={disabled} className={className}>
          <FormattedMessage {...messages.header} />
        </label>
      </p>
    </Wrapper>
  );
}

ImportGpx.propTypes = {
  className: PropTypes.string,
  disabled: PropTypes.bool,
  title: PropTypes.string,
  onChange: PropTypes.func,
};

export default ImportGpx;
